var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page",class:{
    'page--content-only': _vm.contentOnly,
    'page--small': _vm.small,
  }},[_vm._t("pagenav"),_c('div',{staticClass:"page__title"},[(_vm.title)?_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"page__actions"},[_vm._t("actions")],2)]),_c('div',{staticClass:"page__content-wrapper"},[(!_vm.contentOnly)?_c('div',{staticClass:"page__column"},[_vm._t("column")],2):_vm._e(),_c('div',{staticClass:"page__content"},[_vm._t("content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }